import React, { useEffect, useState } from "react";
import axiosConfig from "../../AxiosConfig";
import * as XLSX from "xlsx";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import Swal from "sweetalert2";
export default function WorkerReport() {
  const [workers, setWorkers] = useState([]);
  const [worker, setWorker] = useState("");
  const [financialYear, setFinancialYear] = useState("");
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [target, setTarget] = useState("");
  const [selectedReportProduct, setSelectedReportProduct] = useState("");
const [products, setProducts] = useState([]);
  const [targetData, setTargetData] = useState({
    product: "",
    worker: worker,
    financialYear: financialYear,
    qty: "",
    sqInch: "",
    weight: "",
  });
  const [targetModal, setTargetModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState("");
  const [qty, setQty] = useState("");
  const [sqInch, setSqInch] = useState("");
  const [weight, setWeight] = useState("");
  useEffect(() => {
    getWorkers();
     getProducts();
    setFinancialYear(getCurrentFinancialYear());
  }, []);

  const getCurrentFinancialYear = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1;

    return month >= 4 ? `${year}-${year + 1}` : `${year - 1}-${year}`;
  };

  const getFinancialYearOptions = () => {
    const current = new Date().getFullYear();

    let arr = [];

    for (let i = -5; i <= 5; i++) {
      const y = current + i;
      arr.push(`${y}-${y + 1}`);
    }

    return arr;
  };
const getProducts = async () => {
  try {
    const user = JSON.parse(localStorage.getItem("userData"));

    const res = await axiosConfig.get(
      `/product/view-product-purchase/${user.database}`
    );

    console.log("PRODUCTS =>", res.data);

    setProducts(res?.data?.Product || []);
  } catch (err) {
    console.log("Product Error =>", err);
    setProducts([]);
  }
};
  const getWorkers = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("userData"));

      const res = await axiosConfig.get(
        `/user/view-user-by-id/${user._id}/${user.database}`
      );

      const list = res.data.adminDetails || [];

      setWorkers(list);

      // Default Worker = Cutting
      const cuttingWorker = list.find(
        (item) => item.firstName?.toLowerCase() === "cutting operator"
      );
      if (cuttingWorker) {
        setWorker(cuttingWorker._id);
      }
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    if (worker && financialYear) {
      handleSearch();
    }
  }, [worker, financialYear]);
  const handleSearch = async () => {
    if (!worker) return;

    setLoading(true);

    try {
      const res = await axiosConfig.get(
        `/production-steps/worker-report/${financialYear}/${worker}`
      );

      setReportData(res.data.report || []);
    } catch (err) {
      console.log(err);
      setReportData([]);
    } finally {
      setLoading(false);
    }
  };
  const handleTarget = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("userData"));

      const payload = {
        database: user.database,
        workerId: worker,
        finanaceYear: financialYear,
        products: [
          {
            productId: selectedProduct,
            qty: Number(qty),
            sqInch: Number(sqInch),
            weight: Number(weight),
          },
        ],
      };

      const res = await axiosConfig.post(
        "/production-steps/save-worker-target",
        payload
      );

      await Swal.fire({
        icon: "success",
        title: "Success",
        text: "Target Saved Successfully",
        confirmButtonText: "OK",
        confirmButtonColor: "#3085d6",
      });

      setTargetModal(false);
      setSelectedProduct("");
      setQty("");
      setSqInch("");
      setWeight("");
    } catch (err) {
      console.log(err);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: err?.response?.data?.message || "Something went wrong",
      });
    }
  };
  const handleBalance = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("userData"));

      const res = await axiosConfig.get(
        `/your-balance-api/${user.database}/${financialYear}/${worker}`
      );

      console.log(res.data);
    } catch (err) {
      console.log(err);
    }
  };
  const exportExcel = () => {
    const exportData = [];

    reportData.forEach((item) => {
      exportData.push({
        Date: item.date,
        Product: item.productName,

        ReturnQty: item.returnQty,
        ReturnSqInch: item.returnSqInch,
        ReturnWeight: item.returnWeight,

        WastageQty: item.wastageQty,
        WastageSqInch: item.wastageSqInch,
        WastageWeight: item.wastageWeight,

        CompletionDate: item.completionDate,
        CompletionTime: item.completionTime,
      });
    });

    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb, ws, "Worker Report");

    XLSX.writeFile(wb, "WorkerReport.xlsx");
  };

  return (
    <><div className="container-fluid">

      <div className="card">

        <div className="card-header">
          <h4>Worker Report</h4>
        </div>

        <div className="card-body">

          <div className="row mb-3">

            <div className="col-md-2">
              <label>Worker</label>

              <select
                className="form-control"
                value={worker}
                onChange={(e) => setWorker(e.target.value)}
              >
                <option value="">Select Worker</option>

                {workers.map((w) => (
                  <option key={w._id} value={w._id}>
                    {w.firstName}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-2">
              <label>Financial Year</label>

              <select
                className="form-control"
                value={financialYear}
                onChange={(e) => setFinancialYear(e.target.value)}
              >
                {getFinancialYearOptions().map((fy) => (
                  <option key={fy}>{fy}</option>
                ))}
              </select>
            </div>
            <div className="col-md-3">
  <label>Product</label>

  <select
    className="form-control"
    value={selectedReportProduct}
    onChange={(e) => {
      setSelectedReportProduct(e.target.value);
    }}
  >
    <option value="">Select Product</option>

    {products.map((product) => (
      <option
        key={product._id}
        value={product._id}
      >
        {product.Product_Title}
      </option>
    ))}
  </select>
</div>
            <div className="col-md-2">
              <label>Target</label>

              <div className="border rounded p-2">
                <div className="d-flex justify-content-between">
                  <span>SqInch</span>
                  <strong>0</strong>
                </div>

                <div className="d-flex justify-content-between mt-1">
                  <span>Weight</span>
                  <strong>0</strong>
                </div>
              </div>
            </div>

            <div className="col-md-2">
              <label>Balance</label>

              <div className="border rounded p-2">
                <div className="d-flex justify-content-between">
                  <span>SqInch</span>
                  <strong>0</strong>
                </div>

                <div className="d-flex justify-content-between mt-1">
                  <span>Weight</span>
                  <strong>0</strong>
                </div>
              </div>
            </div>
          </div>

          <div className="table-responsive">

            <table className="table table-bordered text-center">

              <thead>

                <tr>
                  <th rowSpan="2">Date</th>
                  <th rowSpan="2">Product Name</th>

                  <th colSpan="3" style={{
                    backgroundColor: "#d1ecf1", // Light Blue
                    color: "#0c5460",
                  }}>Return Product Details</th>

                  <th colSpan="3" style={{
                    backgroundColor: "#f8d7da", // Light Red
                    color: "#721c24",
                  }}>Wastage Product Details</th>

                  <th rowSpan="2">Completion Date</th>
                  <th rowSpan="2">Completion Time</th>
                </tr>

                <tr>
                  <th style={{
                    backgroundColor: "#d1ecf1", // Light Blue
                    color: "#0c5460",
                  }}>Qty</th>
                  <th style={{
                    backgroundColor: "#d1ecf1", // Light Blue
                    color: "#0c5460",
                  }}>SqInch</th>
                  <th style={{
                    backgroundColor: "#d1ecf1", // Light Blue
                    color: "#0c5460",
                  }}>Weight</th>

                  <th  style={{
                    backgroundColor: "#f8d7da", // Light Red
                    color: "#721c24",
                  }}>Qty</th>
                  <th  style={{
                    backgroundColor: "#f8d7da", // Light Red
                    color: "#721c24",
                  }}>SqInch</th>
                  <th  style={{
                    backgroundColor: "#f8d7da", // Light Red
                    color: "#721c24",
                  }}>Weight</th>
                </tr>

              </thead>

              <tbody>
                {reportData.length > 0 ? (
                  reportData.map((item, index) => {
                    const detail = item.product_details;
                    const returnProduct = detail?.finalProductDetails?.[0];

                    const wastageProduct = detail?.wastageProductDetails?.[0];
                    const returnUnits = returnProduct?.fProduct_name_Units || [];

                    const wastageUnits = wastageProduct?.wProduct_name_Units || [];

                    const getQty = (arr, unit) => arr.find(
                      (u) => u.unit?.toLowerCase() === unit.toLowerCase()
                    )?.qty ?? "-";

                    return (
                      <tr key={index}>
                        <td>
                          {new Date(item.date).toLocaleDateString("en-GB")}
                        </td>

                        <td>
                          {detail?.rProduct_name?.Product_Title || "-"}
                        </td>
                        <td>{getQty(returnUnits, "sheet")}</td>
                        <td>{getQty(returnUnits, "SQINCH")}</td>
                        <td>{getQty(returnUnits, "Kg")}</td>

                        <td>{getQty(wastageUnits, "sheet")}</td>
                        <td>{getQty(wastageUnits, "SQINCH")}</td>
                        <td>{getQty(wastageUnits, "Kg")}</td>

                        <td>
                          {detail?.status === "Completed"
                            ? new Date(item.date).toLocaleDateString("en-GB")
                            : "-"}
                        </td>

                        <td>
                          {detail?.status === "Completed"
                            ? new Date(item.date).toLocaleTimeString("en-GB", {
                              hour: "2-digit",
                              minute: "2-digit",
                              second: "2-digit",
                              hour12: true,
                            })
                            : "-"}
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="10">No Data Found</td>
                  </tr>
                )}

              </tbody>

            </table>

          </div>

        </div>

      </div>

    </div>

    </>

  );

}